import styled, { keyframes } from 'styled-components';
import { Accordion, AccordionItem, AccordionItemButton, AccordionItemPanel } from 'react-accessible-accordion';
import { FaChevronDown } from 'react-icons/fa';
import '../../../../../log2base2.css';

const OfferShine = keyframes`
  100% {
    transform: translateX(480px) skewX(-20deg);
  }
`;

export const Container = styled.div``;

export const SyllabusContainer = styled.div`
  width: 100%;
  margin-bottom: 45px;
  @media (min-width: 768px) {
    margin-bottom: 55px;
  }
  :last-child {
    margin-bottom: 0px;
  }
`;

export const SyllabusTitle = styled.h2`
  display: inline-block;
  font-weight: 600 !important;
  padding-bottom: 24px;
  color: ${({ variant }) =>
    variant === 'partner-plus' ? 'var(--partnerPlusColor)' : variant === 'regionals' ? 'var(--regionalsDark)' : variant === 'code-juniors' ? 'var(--codeJuniorsColor)' : ''};
  background: ${({ variant }) =>
    !(variant === 'partner-plus' || variant === 'regionals' || variant === 'code-juniors') && 'linear-gradient(90deg, var(--gradientPrimaryColor), var(--gradientSecondaryColor))'};
  background-clip: ${({ variant }) => !(variant === 'partner-plus' || variant === 'regionals' || variant === 'code-juniors') && 'text'};
  -webkit-text-fill-color: ${({ variant }) => !(variant === 'partner-plus' || variant === 'regionals' || variant === 'code-juniors') && 'transparent'};
`;

export const SyllabusWithPricingGrid = styled.div`
  width: 100%;
  @media (min-width: 992px) {
    display: ${({ isSidePricing }) => isSidePricing && 'grid'};
    grid-template-columns: ${({ isSidePricing }) => isSidePricing && 'calc(96% - 320px) 320px'};
    justify-content: ${({ isSidePricing }) => isSidePricing && 'space-between'};
    column-gap: ${({ isSidePricing }) => isSidePricing && '4%'};
  }
  @media (min-width: 1400px) {
    grid-template-columns: ${({ isSidePricing }) => isSidePricing && 'calc(96% - 340px) 340px'};
  }
`;
export const SyllabusSidePricingContainer = styled.div`
  margin-top: 50px;
  @media (min-width: 992px) {
    margin-top: 58px;
  }
`;
export const SyllabusSidePricingWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 340px;
  padding: 45px 1rem 1rem 1rem;
  margin: auto;
  border-radius: 10px;
  background-color: white;
  box-shadow: 0px 8px 25px var(--greyShadowColor);
  overflow: hidden;
  @media (min-width: 992px) {
    position: sticky;
    top: ${({ headerOfferSnackbar }) => (headerOfferSnackbar ? 'calc(var(--headerHeight) + var(--topOfferSnackbarHeight) + 12px)' : 'calc(var(--headerHeight) + 12px)')};
    max-width: unset;
    margin: 0px 0px 0px auto;
  }
  @media (min-width: 1400px) {
    top: ${({ headerOfferSnackbar }) => (headerOfferSnackbar ? 'calc(var(--headerHeight) + var(--topOfferSnackbarHeight) + 24px)' : 'calc(var(--headerHeight) + 24px)')};
  }
  @media (min-width: 1800px) {
    top: ${({ headerOfferSnackbar }) => (headerOfferSnackbar ? 'calc(var(--headerHeight) + var(--topOfferSnackbarHeight) + 32px)' : 'calc(var(--headerHeight) + 32px)')};
  }
`;
export const PriceCardShiningHeadOuter = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 35px;
  border-radius: 10px 10px 0px 0px;
`;
export const PriceCardShiningHeadInner = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-family: var(--headingFont);
  font-weight: 500;
  color: #fff;
  background: ${({ courseTheme }) =>
    courseTheme === 'partner-plus'
      ? 'var(--partnerPlusColor)'
      : courseTheme === 'code-juniors'
      ? 'var(--codeJuniorsColor)'
      : courseTheme === 'regionals'
      ? 'var(--regionalsColor)'
      : 'var(--brandColor)'};
  border-radius: inherit;
  overflow: hidden;
  &::before {
    content: '';
    position: absolute;
    width: 35px;
    height: 70px;
    left: -60px;
    background-color: #ffffff42;
    filter: blur(15px);
    transform: skewX(-20deg);
    animation: ${OfferShine} 4.5s ease-in-out infinite;
  }
`;
export const SlantingOfferBadge = styled.div`
  position: absolute;
  top: 22px;
  right: -40px;
  width: 150px;
  padding: 2px 30px;
  font-size: 15px;
  text-align: center;
  color: var(--btnDarkTxt);
  background: var(--pricingBarYellow);
  transform: rotate(45deg);
  z-index: 5;
`;
export const DescriptionTextToggle = styled.span`
  display: none;
  color: ${({ courseTheme }) =>
    courseTheme === 'partner-plus'
      ? 'var(--partnerPlusColor)'
      : courseTheme === 'code-juniors'
      ? 'var(--codeJuniorsColor)'
      : courseTheme === 'regionals'
      ? 'var(--regionalsColor)'
      : 'var(--brandColor)'};
  margin-left: 4px;
  font-weight: 600;
  cursor: pointer;
  @media (min-width: 992px) {
    display: inline;
  }
  @media (min-width: 1400px) {
    display: none;
  }
`;
export const SecondaryCTA = styled.span`
  display: inline-block;
  font-family: var(--headingFont);
  font-weight: 600;
  color: ${({ courseTheme }) =>
    courseTheme === 'partner-plus'
      ? 'var(--partnerPlusColor)'
      : courseTheme === 'code-juniors'
      ? 'var(--codeJuniorsColor)'
      : courseTheme === 'regionals'
      ? 'var(--regionalsColor)'
      : 'var(--brandColor)'};
  cursor: pointer;
`;

// packages syllabus card styles
export const PackageSyllabusCard = styled(Accordion)`
  width: 100%;
  background: var(--siteBgColor);
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid var(--greyShadowColor);
`;

export const PackageItemContainer = styled(AccordionItem)``;

export const PackageCardExpand = styled(FaChevronDown)`
  color: ${({ variant }) =>
    variant === 'partner-plus'
      ? 'var(--partnerPlusColor)'
      : variant === 'regionals'
      ? 'var(--regionalsColor)'
      : variant === 'code-juniors'
      ? 'var(--codeJuniorsColor)'
      : 'var(--brandColor)'};
  font-size: 14px;
  transform: rotateZ(0deg);
  transition: transform 0.3s;
  @media (min-width: 992px) {
    font-size: 16px;
  }
`;

export const PackageCardButton = styled(AccordionItemButton)`
  display: flex;
  justify-content: space-between;
  cursor: ${(props) => props.courseSyllabus && 'default !important'};
  padding: 16px;
  @media (min-width: 576px) {
    padding: 18px;
  }
  @media (min-width: 768px) {
    padding: 20px;
  }
  @media (min-width: 992px) {
    padding: 24px;
  }
  :focus {
    outline: none;
  }
  &[aria-expanded='true'] ${PackageCardExpand} {
    transform: rotateZ(180deg);
  }
`;

export const PackageCardTitleWrapper = styled.div`
  display: flex;
`;

export const PackageSyllabusIconWrapper = styled.div`
  width: 28px;
  height: fit-content;
  border-radius: 5px;
  padding: 2px;
  display: flex;
  border: 1px solid var(--greyShadowColor);
  @media (min-width: 481px) {
    width: 30px;
  }
  @media (min-width: 576px) {
    width: 32px;
  }
  @media (min-width: 992px) {
    width: 34px;
  }
  @media (min-width: 1200px) {
    width: 36px;
  }
  @media (min-width: 1400px) {
    width: 38px;
  }
  @media (min-width: 2000px) {
    width: 40px;
  }
`;

export const PackageSyllabusIcon = styled.img`
  min-width: 100%;
`;

export const PackageCardTitle = styled.h2`
  padding-left: 10px;
  padding-bottom: 0px;
  color: var(--inputTxtColor) !important;
  font-size: 20px !important;
  @media (min-width: 481px) {
    font-size: 22px !important;
  }
  @media (min-width: 576px) {
    font-size: 24px !important;
  }
  @media (min-width: 992px) {
    font-size: 26px !important;
  }
  @media (min-width: 1200px) {
    font-size: 28px !important;
  }
  @media (min-width: 1400px) {
    font-size: 30px !important;
  }
  @media (min-width: 2000px) {
    font-size: 32px !important;
  }
`;

export const PackageCardDescription = styled.p`
  display: none;
  color: var(--darkGreyTxtColor);
  line-height: normal;
  font-size: 14px;
  @media (min-width: 768px) {
    display: block;
    padding-top: 16px;
    font-size: 15px;
  }
  @media (min-width: 1200px) {
    font-size: 16px;
  }
`;

export const PackageCardBody = styled(AccordionItemPanel)``;

// trials videos styles
export const TrialsWrapper = styled(AccordionItemPanel)`
  width: 95%;
  margin: 0 auto;
  padding: 5px 0px 10px 0px;
  transition: all 0.2s ease-out;
  display: flex;
  flex-wrap: wrap;
  @media (min-width: 576px) {
    width: 90%;
    padding: 10px 0px 15px 0px;
  }
  @media (min-width: 992px) {
    padding: 10px 0px 30px 0px;
  }
  @media (min-width: 1600px) {
    padding: 10px 0px 30px 0px;
  }
`;

export const TrialCardWrapper = styled.div`
  width: 100%;
  padding: 0px 8px 24px 8px;
  @media (min-width: 481px) {
    max-width: 49%;
    padding: 0px 8px 24px 8px;
    margin-right: 2%;
    :nth-child(even) {
      margin-right: unset;
    }
  }
  @media (min-width: 992px) {
    max-width: ${({ isSidePricing }) => !isSidePricing && '24%'};
    padding: ${({ isSidePricing }) => !isSidePricing && '0px 8px'};
    margin-right: ${({ isSidePricing }) => !isSidePricing && '1%'};
    :nth-child(2) {
      margin-right: ${({ isSidePricing }) => !isSidePricing && '1%'};
    }
    :last-child {
      margin-right: ${({ isSidePricing }) => !isSidePricing && 'unset'};
    }
  }
  @media (min-width: 1500px) {
    max-width: 24%;
    padding: 0px 8px;
    margin-right: 1%;
    :nth-child(2) {
      margin-right: 1%;
    }
    :last-child {
      margin-right: unset;
    }
  }
`;

export const TialVideosCard = styled.div`
  width: 100%;
  cursor: ${(props) => (props.nonclickable ? 'default' : 'pointer')};
`;

export const TrialImgContainer = styled.div`
  position: relative;
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0px 0px 1px var(--secondary);
`;

export const TrialImg = styled.img`
  width: 100%;
`;

export const TrialPlayIcon = styled.img`
  position: absolute;
  width: 16%;
  max-width: 50px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: transform 0.15s;
  pointer-events: none;
  box-shadow: 0px 0px 10px var(--greyShadowColor);
  border-radius: 50%;
  ${TialVideosCard}:hover & {
    transform: translate(-50%, -50%) scale(1.1);
  }
`;

export const TrialText = styled.p`
  font-size: 14px;
  line-height: normal;
  padding-top: 8px;
  color: var(--darkGreyTxtColor);
`;

// trial video tags
export const TrialVideosTag = styled.span`
  position: absolute;
  top: 5px;
  right: 0px;
  font-size: 11px;
  line-height: normal;
  text-align: center;
  color: #fff;
  background: ${(props) =>
    props.upComing
      ? 'linear-gradient(135deg, var(--indigo), var(--purple))'
      : props.newCourse
      ? 'linear-gradient(135deg, var(--yellow), var(--orange))'
      : props.freeVideo
      ? 'linear-gradient(135deg, var(--highlightColor), var(--green))'
      : props.signupRequired
      ? 'linear-gradient(135deg, var(--brandColor), var(--info))'
      : '#2575fceb'};
  box-shadow: 0px 0px 10px var(--greyShadowColor);
  padding: 4px 6px 4px 8px;
  border-radius: 12px 0px 0px 12px;
`;

// syllabus accordian styles
export const AccordionHeader = styled(Accordion)`
  width: 100%;
  background: var(--siteBgColor);
`;

export const AccordionItemContainer = styled(AccordionItem)`
  border-top: 1px solid var(--greyShadowColor);
`;

export const AccordionExpand = styled(FaChevronDown)`
  color: ${({ variant }) =>
    variant === 'partner-plus'
      ? 'var(--partnerPlusColor)'
      : variant === 'regionals'
      ? 'var(--regionalsColor)'
      : variant === 'code-juniors'
      ? 'var(--codeJuniorsColor)'
      : 'var(--brandColor)'};
  font-size: 16px;
  transform: rotateZ(0deg);
  transition: transform 0.4s;
  @media (min-width: 576px) {
    font-size: 18px;
  }
`;

export const TitleRow = styled(AccordionItemButton)`
  width: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-radius: 5px;
  overflow: hidden;
  @media (min-width: 576px) {
    padding: 20px 4%;
  }
  :focus {
    outline: none;
  }
  &[aria-expanded='true'] ${AccordionExpand} {
    transform: rotateZ(180deg);
  }
`;

export const TitleContent = styled.p`
  width: 100%;
  display: flex;
  align-items: center;
  font-family: var(--headingFont) !important;
  font-weight: 500;
  font-size: 15px;
  padding-right: 8px;
  @media (min-width: 576px) {
    font-size: 16px;
  }
`;

export const AccordionBody = styled(AccordionItemPanel)`
  padding: 12px 8px;
  cursor: ${(props) => (props.nonclickable ? 'default' : 'pointer')};
  transition: all 0.2s ease-out;
  width: 95%;
  margin: 0 auto;
  :hover {
    background: ${({ courseTheme }) =>
      courseTheme === 'partner-plus'
        ? '#f4fbf6'
        : courseTheme === 'regionals'
        ? '#f9f1f9'
        : courseTheme === 'code-juniors'
        ? 'var(--juniorsSnackbar)'
        : 'var(--siteSecondaryBgColor)'};
    border-radius: 5px;
  }
  @media (min-width: 576px) {
    width: 90%;
    padding: 14px 2%;
  }
`;

export const BodyRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SyllabusVideoIcon = styled.img`
  width: 16px;
  @media (min-width: 576px) {
    width: 18px;
  }
`;

export const BodyTitle = styled.p`
  font-size: 14px;
  color: var(--darkGreyTxtColor);
  line-height: normal;
  padding: 0px 10px;
  display: flex;
  row-gap: 5px;
  column-gap: 10px;
  flex-wrap: wrap;
  @media (min-width: 576px) {
    font-size: 15px;
    padding: 0px 20px;
  }
`;

export const SyllabusEarlyAccessText = styled.div`
  width: 100%;
  padding: 6px 16px;
  margin: 0 auto 16px;
  font-size: 14px;
  background-color: var(--light);
  @media (min-width: 481px) {
    width: calc(100% - 32px);
    padding: 6px 12px;
    border-radius: 4px;
  }
  @media (min-width: 576px) {
    width: 92%;
    padding: 8px 16px;
    font-size: 15px;
  }
`;

export const SyllabusLockIcon = styled.img`
  width: 16px;
  @media (min-width: 576px) {
    width: 18px;
  }
`;

// syllabus tags
export const SyllabusTag = styled.span`
  font-size: 10px;
  color: ${({ earlyAccess }) => (earlyAccess ? 'var(--dark)' : '#fff')};
  background: ${({ upComing, newCourse, earlyAccess }) => (upComing ? 'var(--info)' : newCourse ? 'var(--orange)' : earlyAccess ? 'var(--warning)' : 'var(--brandColor)')};
  text-transform: uppercase;
  padding: ${(props) => (props.syllabusNav ? '3px 6px' : '4px 8px')};
  margin-left: ${(props) => props.titleTag && '8px'};
  line-height: normal;
  border-radius: 15px;
`;

// package syllabus navigation
export const SyllabusNavContainer = styled.div`
  width: 100%;
  background-color: var(--siteBgColor);
  border: 1px solid var(--greyShadowColor);
  padding: 20px;
  margin-bottom: 35px;
  border-radius: 6px;
  @media (min-width: 481px) {
    padding: 25px;
  }
  @media (min-width: 768px) {
    padding: 30px;
  }
`;

export const SyllabusNavItem = styled.div`
  display: flex;
  align-items: center;
  min-height: 48px;
  padding: 5px;
  margin-bottom: 20px;
  border-radius: 6px;
  cursor: ${({ isNotAvailable }) => !isNotAvailable && 'pointer'};
  background-color: var(--siteBgColor);
  border: 1px solid var(--greyShadowColor);
  transition: 0.1s;
  :last-child {
    margin-bottom: 0px;
  }
  :hover {
    background-color: ${({ isNotAvailable, courseTheme }) =>
      !isNotAvailable &&
      (courseTheme === 'partner-plus'
        ? '#f4fbf6'
        : courseTheme === 'regionals'
        ? '#f9f1f9'
        : courseTheme === 'code-juniors'
        ? 'var(--juniorsSnackbar)'
        : 'var(--siteSecondaryBgColor)')};
    border-color: ${({ isNotAvailable, courseTheme }) =>
      !isNotAvailable &&
      (courseTheme === 'partner-plus' ? '#1e8e3e30' : courseTheme === 'regionals' ? '#82368033' : courseTheme === 'code-juniors' ? '#ff683d47' : 'var(--blueShadowColor)')};
  }
  @media (min-width: 576px) {
    padding: 5px 10px;
  }
`;

export const SyllabusNavImg = styled.img`
  width: 34px;
  @media (min-width: 992px) {
    width: 36px;
  }
`;

export const SyllabusNavText = styled.p`
  padding-left: 10px;
  font-size: 14px;
  line-height: normal;
  @media (min-width: 1200px) {
    padding-left: 12px;
  }
`;

// course syllabus bar
export const CourseSyllabusBar = styled.div`
  color: ${(props) => (props.earlyAccess ? 'var(--dark)' : 'white')};
  background: ${(props) => (props.earlyAccess ? 'var(--warning)' : props.freeCourse ? 'var(--gradientSecondaryColor)' : 'var(--brandColor)')};
  text-align: center;
  overflow: hidden;
  padding: 6px;
  border-radius: 4px;
  margin-bottom: 2rem;
  box-shadow: 0px 0px 5px var(--greyShadowColor);
  font-size: 14px;
  @media (min-width: 360px) {
    font-size: 15px;
  }
  @media (min-width: 768px) {
    font-size: 16px;
    padding: 8px;
  }
`;
